var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"client-card"},[_c('e-img',{staticClass:"icon",class:{ 'bg': _vm.bg },attrs:{"lazy":"","src":_vm.src,"alt":_vm.altTag}}),_c('div',{staticClass:"name"},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }